/**
 * Theme-Store: Light/Dark mit System-Default. Setzt data-theme auf <html>
 * und persistiert die Wahl. Dark ist der Marken-Default.
 */
import { effect, signal } from "@preact/signals";

export type ThemePref = "dark" | "light" | "system";

const KEY = "sentinus.theme";

function systemPrefersLight(): boolean {
  return (
    typeof matchMedia !== "undefined" &&
    matchMedia("(prefers-color-scheme: light)").matches
  );
}

export const themePref = signal<ThemePref>(
  (localStorage.getItem(KEY) as ThemePref) || "dark",
);

function resolved(pref: ThemePref): "dark" | "light" {
  if (pref === "system") return systemPrefersLight() ? "light" : "dark";
  return pref;
}

// Anwenden + persistieren, wann immer sich die Präferenz ändert.
effect(() => {
  const theme = resolved(themePref.value);
  document.documentElement.setAttribute("data-theme", theme);
  localStorage.setItem(KEY, themePref.value);
});

export function cycleTheme(): void {
  const order: ThemePref[] = ["system", "dark", "light"];
  const i = order.indexOf(themePref.value);
  themePref.value = order[(i + 1) % order.length];
}
